import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade update-user-modal",
  id: "UpdateCategoryModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "modal-title fs-5" }, "Editar categoria"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close update-user-modal",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_5 = { class: "modal-body ps-30 pe-30" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-danger fs-md-15 fs-lg-16",
  role: "alert"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Preencha as informações abaixo para atualizar a categoria", -1)
const _hoisted_8 = { class: "mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "name_category_update",
  class: "form-label fw-medium"
}, "Categoria", -1)
const _hoisted_10 = { class: "form-check mb-20 col-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "active_category_update"
}, " Categoria ativa ", -1)
const _hoisted_12 = { class: "mb-20 col-12" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium" }, "Usuários vinculados", -1)
const _hoisted_14 = {
  key: 0,
  class: "border rounded-2 p-15",
  style: {"max-height":"260px","overflow-y":"auto"}
}
const _hoisted_15 = ["id", "value"]
const _hoisted_16 = ["for"]
const _hoisted_17 = { class: "fw-medium text-black-emphasis" }
const _hoisted_18 = { class: "d-block text-body-tertiary" }
const _hoisted_19 = {
  key: 1,
  class: "border rounded-2 p-15 text-body-tertiary"
}
const _hoisted_20 = { class: "modal-footer" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, "Cancelar", -1)
const _hoisted_22 = {
  type: "submit",
  ref: "buttonUpdateCategory",
  class: "btn btn-success"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("form", {
          ref: "formUpdateCategory",
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateCategoryMethod && _ctx.updateCategoryMethod(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.categoryName) = $event)),
                type: "text",
                class: "form-control shadow-none text-black fs-md-15 fs-lg-16",
                id: "name_category_update",
                placeholder: "Digite a categoria",
                autocomplete: "off",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.categoryName]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                id: "active_category_update",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isActive) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.isActive]
              ]),
              _hoisted_11
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              (_ctx.availableUsers.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableUsers, (user) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: user.id,
                        class: "form-check mb-12"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          id: `category-user-${user.id}`,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedUserIds) = $event)),
                          value: user.id,
                          class: "form-check-input",
                          type: "checkbox"
                        }, null, 8, _hoisted_15), [
                          [_vModelCheckbox, _ctx.selectedUserIds]
                        ]),
                        _createElementVNode("label", {
                          class: "form-check-label d-block",
                          for: `category-user-${user.id}`
                        }, [
                          _createElementVNode("span", _hoisted_17, _toDisplayString(user.name), 1),
                          _createElementVNode("small", _hoisted_18, _toDisplayString(user.email || user.phone || 'Sem contato cadastrado'), 1)
                        ], 8, _hoisted_16)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_19, " Nenhum usuário disponível para vincular. "))
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("button", _hoisted_22, "Salvar categoria", 512)
            ])
          ])
        ], 544)
      ])
    ])
  ]))
}